import { BaseResponse } from '../../../../../../../types/api/api.types';
import { CONSULTATIONS_ENDPOINTS } from '../../../../../../../utils/api/endpoints/consultationsEndpoints';
import { CloseConsultationQuery } from './CloseConsultationModal.types';

const PREFIX = '[closeConsultationQuery]';

export const CLOSE_CONSULTATION_QUERY_KEY = 'CLOSE_CONSULTATION';

export const closeConsultationQuery = async ({ consultationId }: CloseConsultationQuery) => {
  console.log(PREFIX, `Requesting close consultation...`);

  const response = await CONSULTATIONS_ENDPOINTS.close(consultationId);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received close consultation.`);
  return json as BaseResponse;
};
